import { useEffect, useState } from "react";
import { useAuthStore } from "../stores/useAuthStore";

const ENABLED_KEY = "trekkin_admin_user_view_v1";
const ROLE_KEY = "trekkin_admin_user_view_role_v1";
const PREVIEW_ROLES = new Set(["free", "explorer", "adventure", "guide"]);

function readPreview(realRole) {
  if (realRole !== "admin") return { enabled: false, role: realRole };
  try {
    const enabled = window.localStorage.getItem(ENABLED_KEY) === "1";
    const selected = String(window.localStorage.getItem(ROLE_KEY) || "free").toLowerCase();
    return { enabled, role: enabled && PREVIEW_ROLES.has(selected) ? selected : realRole };
  } catch {
    return { enabled: false, role: realRole };
  }
}

export function useEffectiveRole() {
  const realRole = useAuthStore((state) => String(state.user?.role || "").toLowerCase());
  const [preview, setPreview] = useState(() => readPreview(realRole));

  useEffect(() => {
    const sync = (event) => {
      const stored = readPreview(realRole);
      const hasEventState = typeof event?.detail?.enabled === "boolean";
      const enabled = hasEventState ? event.detail.enabled : stored.enabled;
      const eventRole = String(event?.detail?.role || "").toLowerCase();
      const selected = PREVIEW_ROLES.has(eventRole) ? eventRole : stored.role;
      setPreview({ enabled: realRole === "admin" && enabled, role: selected });
    };
    sync();
    window.addEventListener("storage", sync);
    window.addEventListener("trekkin:admin-user-view", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("trekkin:admin-user-view", sync);
    };
  }, [realRole]);

  return {
    realRole,
    effectiveRole: preview.enabled ? preview.role : realRole,
    isPreviewing: realRole === "admin" && preview.enabled,
  };
}
